"use client";

import { createContext } from "react";
import type {
  BrowserPermissionState,
  ResponseFeedbackProps,
  TaskBarProps,
  UserPromptRecord,
} from "@huub-web/ui";

export type TaskbarControllerContextState = {
  // State
  isRecording: boolean;
  isDisabled: boolean;
  isLoading: boolean;
  isProcessingRecording: boolean;
  hasFeedbackBeenSend: boolean;
  isFeedbackLoading: boolean;
  volume: number;
  transcription: string;
  suggestions: UserPromptRecord[];
  hasCanvasTaskBar: boolean;
  lastUserPrompt: string | null;
  lastUserPromptType: TaskBarProps["promptType"];
  microphonePermissionState: BrowserPermissionState;

  // Handlers
  handleSuggestionClick: (suggestion: UserPromptRecord) => void;
  handleMessage: (message: string) => void;
  handleMessageStop: () => void;
  handleFeedbackSubmit: ResponseFeedbackProps["onSubmit"];
  handleAudioToggle: () => void;
  handleRecord: () => void;
  handleRecordStop: () => void;
};

export const TaskbarControllerContext = createContext<
  TaskbarControllerContextState | undefined
>(undefined);
